var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sau-service-status',{attrs:{"service":_vm.service}}),_vm._v(" "),(Object.keys(_vm.service.custom).length > 0)?[_c('sau-service-common-system',{staticClass:"pt-12",attrs:{"service":_vm.service}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }